import dynamic from "next/dynamic";

import ArticlesTopicFilterBar from "components/Reusables/FilterBar/ArticlesTopicFilterBar";
import AssessmentsFilterBar from "components/Reusables/FilterBar/AssessmentsFilterBar";
import BoardApplyNavigation from "components/Reusables/FilterBar/BoardApplyNavigation";
import WelcomeNavigation from "components/Reusables/FilterBar/WelcomeNavigation";
import BooksFilterBar from "components/Reusables/FilterBar/BooksFilterBar";
import CenteredContainer from "components/Reusables/CenteredContainer";
import CheckList from "components/Reusables/CheckList";
import ConferenceScheduleAtGlance from "components/CustomTables/ConferenceScheduleAtGlance";
import CourseFilterBar from "components/Reusables/FilterBar/CourseFilterBar";
import LibraryFilterBar from "components/Reusables/FilterBar/LibraryFilterBar";

import FastPracticeMediaCardSection from "components/Reusables/FastPracticeMediaCardSection";
import FeaturedArticle from "components/Reusables/FeaturedArticle";
import FeaturedArticleMediaCardSection from "components/Reusables/FeaturedArticleMediaCardSection";
import JobPostings from "components/Reusables/JobPostings";
import JournalEditionsList from "components/JournalEditionsList";
import Jumbotron from "components/Reusables/Jumbotron";
import LeftRightFullHeight from "components/Reusables/LeftRightFullHeight";
import LeftRightOffset from "components/Reusables/LeftRightOffset";
import MediaCardSection from "components/Reusables/MediaCardSection";
import MembershipBenefitsList from "components/Reusables/MembershipBenefitsList";
import MultiColumnTextAndImage from "components/Reusables/MultiColumnTextAndImage";
import ProductsMediaCardSection from "components/Reusables/ProductsMediaCardSection";
import Quote from "components/Reusables/Quote";
import RenderProductCollection from "components/Reusables/RenderProductCollection";
import RenderPressReleaseList from "components/Reusables/RenderPressReleaseList";
import StatsSection from "components/Reusables/StatsSection";
import TileCardsDisplay from "components/Reusables/TileCardsDisplay";
import ActionItems from "components/Reusables/ActionItems";
import AccessKnowledge from "components/Reusables/AccessKnowledge";
import ProfessionalCertificates from "components/Reusables/ProfessionalCertificates";
import LiveAndOnlineEvents from "components/Reusables/LiveAndOnlineEvents";
// import ListingsHeader from '../components/Webinar/WebinarListingsHeader'

// const RenderFeaturedLibraryItems = dynamic(() => import("../components/Reusables/RenderFeaturedLibraryItems"), {
// 	ssr: false,
// });

export default function renderPageSection(section, additionalData = {}, sectionIndex = false) {
	const model = section.sys.contentType.sys.id;

	switch (model) {
		//Json data content model is being used here as an identifier for rendering components
		//or other custom components that are hard coded, but need to be told where to render on the page, /courses, /books
		case "jsonData":
			const { internalName, jsonData } = section.fields;

			if (internalName === "Courses Type Filter") {
				return <CourseFilterBar />;
			} else if (internalName === "Library Search Filter") {
				return <LibraryFilterBar />;
			} else if (internalName === "All Courses Media Card Section") {
				return <ProductsMediaCardSection products={additionalData.products} productType="Course" />;
			} else if (internalName === "Upcoming Webinars") {
				return (
					<ProductsMediaCardSection
						products={additionalData.upcomingWebinarsProducts}
						productType="Webinar"
					/>
				);
			} else if (internalName === "Past Webinars") {
				return (
					<ProductsMediaCardSection products={additionalData.pastWebinarsProducts} productType="Webinar" />
				);
			} else if (internalName === "Render Job Postings") {
				return <JobPostings jobPostings={additionalData.jobPostings} />;
			} else if (internalName === "Fast Practice Collection") {
				const additionalDataKey = jsonData.data;

				return (
					<FastPracticeMediaCardSection //Add the post summaries from the additional data
						additionalData={{ fastPracticeData: additionalData[additionalDataKey] }}
					/>
				);
			} else if (internalName === "Books Type Filter") {
				return <BooksFilterBar />;
			} else if (internalName === "Assessments Type Filter") {
				return <AssessmentsFilterBar />;
			} else if (internalName === "Articles Topic Filter") {
				return <ArticlesTopicFilterBar />;
			} else if (internalName === "Welcome LP Navigation") {
				return <WelcomeNavigation />;
			} else if (internalName === "Board Apply Sub Nav") {
				return <BoardApplyNavigation />;
			} else if (internalName === "Render Featured Article") {
				return <FeaturedArticle data={additionalData} />;
			} else if (internalName.includes("Journal Editions List")) {
				//this should be journalEditions, but it's hard coded anyway
				// const additionalDataKey = jsonData.data;

				return <JournalEditionsList journalEditions={additionalData["journalEditions"]} />;
			} else if (internalName.includes("Render Articles Subset")) {
				//where on additionalData to find the data
				const additionalDataKey = jsonData.data;

				return (
					<FeaturedArticleMediaCardSection //Add the post summaries from the additional data
						additionalData={{ postSummaries: additionalData[additionalDataKey] }}
					/>
				);
			} else if (internalName === "2023 AAPL Annual Leadership Conference - Schedule-at-a-Glance") {
				return <ConferenceScheduleAtGlance />;
			} else if (internalName === "Press Release List") {
				return <RenderPressReleaseList data={additionalData} />;
			} else if (internalName === "Faculty and SME") {
				return <RenderProductCollection data={additionalData} />;
			} else if (internalName === "Capstone Cohort Leaders") {
				return <RenderProductCollection data={additionalData} />;
			} else if (internalName === "Fellowship Fellow Bios") {
				return <RenderProductCollection data={additionalData} />;
			} else if (internalName === "Render Featured Library items") {
				const RenderFeaturedLibraryItems = dynamic(
					() => import("../components/Reusables/RenderFeaturedLibraryItems"),
					{
						ssr: false,
					}
				);
				return <RenderFeaturedLibraryItems data={additionalData} />;
			} else if (internalName === "Access Knowledge Section") {
				return <AccessKnowledge data={section} />;
			}
			else if (internalName === "Professional Certificates") {
				return <ProfessionalCertificates data={section} />;
			}
			else if (internalName === "LiveAndOnlineEvents") {
				return <LiveAndOnlineEvents data={section} additionalData={additionalData} />;
			}
			else if (internalName === "join 250k") {
				return <ActionItems data={additionalData} />;
			}
			else {
				// console.error(`Whats this ${internalName}`);
				return <></>;
			}

		case "productColl":
			return <RenderProductCollection contents={section} data={additionalData} />;

		case "centeredContainer":
			return <CenteredContainer data={section} />;
		case "mainJumbotron": //just a normal Jumbotron, but the name stuck with contentful
			if (section.fields?.internalName === "join 250k healthcare") {
				return <ActionItems data={section} />;
			}
			
			return <Jumbotron data={section} sectionIndex={sectionIndex} />;

		case "multicolumnTextAndImage":
			return <MultiColumnTextAndImage data={section} />;

		case "quoteBlock":
			return <Quote data={section} />;

		case "singleColumnTextAndImage": //TODO this needs to handle offsets or not
			return <LeftRightOffset data={section} sectionIndex={sectionIndex} />;

		case "fullHeightSection":
			return <LeftRightFullHeight data={section} sectionIndex={sectionIndex} />;

		case "checklist":
			return <CheckList data={section} />;

		case "stats":
			if (section.fields.format === "Membership Benefits List") {
				return <MembershipBenefitsList data={section} />;
			}

			return <StatsSection data={section} />;

		case "mediaCardSection":
			if (section.fields?.internalName.includes("Icon Tiles")) {
				return <TileCardsDisplay data={section} />;
			} else {
				return <MediaCardSection data={section} />;
			}

		default:
			return `${model} ${section.fields.internalName} `;
	}
}
